var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tips"},_vm._l((_vm.tips),function(tip,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(tip)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }